<template>
	<div style="height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
		<button @click="searchDevice" style="padding: 10px 20px; font-size: 16px; margin-bottom: 20px;">
			搜索蓝牙设备
		</button>
		<div v-if="connectedDevice">
			<p>已连接设备: {{ connectedDevice.name }}</p>
			<p>最新测量值: {{ measurementValue }}</p>
		</div>
		<div>
			<h1>{{tmp_dat}}</h1>
		</div>
	</div>
</template>

<script>
	import * as tool from '../js/tool.js';
	export default {
		name: "CyclingPowerDemo",
		data() {
			return {
				tmp_dat: null,
				last_crc_time: 0,
				last_crc_count: 0,
				prevCumulativeCrankRevs:null,
				prevCrankEventTime:null,
				
				connectedDevice: null, // 存储已连接的设备
				measurementValue: null, // 存储监听到的测量值
				controlPointCharacteristic: null, // Cycling Power Control Point 特征
				measurementCharacteristic: null, // Cycling Power Measurement 特征
			};
		},
		methods: {
			...tool
		},
		beforeDestroy() {
			// 组件销毁前断开蓝牙设备
			this.disconnectDevice();
		},
	};
</script>

<style>
	button {
		background-color: #007bff;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	button:hover {
		background-color: #0056b3;
	}

	p {
		font-size: 16px;
	}
</style>